import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { CertificateExpiryBanner } from './CertificateExpiryBanner';
import { CertificateMissingBanner } from './CertificateMissingBanner';
import { OfflineBanner } from './OfflineBanner';
import { OfflineToastBridge } from './OfflineToastBridge';
import { SideNav } from './SideNav';
import { TopBar } from './TopBar';

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-(--color-bg) text-(--color-fg) md:flex-row">
      <OfflineToastBridge />
      <SideNav />
      <div className="flex min-w-0 flex-1 flex-col">
        <OfflineBanner />
        <CertificateMissingBanner />
        <CertificateExpiryBanner />
        <TopBar />
        <main className="flex-1 overflow-x-hidden px-4 pt-4 pb-24 md:px-8 md:pb-8">{children}</main>
        <BottomNav />
      </div>
    </div>
  );
}
